export default __webpack_public_path__ + "static/media/logo_constecoin.81a14f93.png";